import type { DownloadLetterPrintJobIntent } from "../actions/downloadLetterPrintJob"

export const buildDownloadLetterPrintJobIntent = ({
  jobId,
  organizationId,
  available,
  completeDelivery = false,
  label = "PDF herunterladen",
}: {
  jobId: string | null
  organizationId: string
  available: boolean
  completeDelivery?: boolean
  label?: string
}): DownloadLetterPrintJobIntent => {
  if (!organizationId) return { kind: "blocked", label, disabledReason: "Organisation fehlt." }

  if (!jobId) return { kind: "blocked", label, disabledReason: "Druckauftrag fehlt." }

  if (!available)
    return { kind: "blocked", label, disabledReason: "Das PDF ist noch nicht fertig." }

  return { kind: "download", label, jobId, organizationId, completeDelivery }
}
